import { RequestHelper } from "../Helpers/RequestHelper.js";
import { Widget } from "./Widget.js";
import { WidgetRates } from "./WidgetRates.js";

export class AdminApp {
    constructor(pmdrs, config) {
        let app = this;
        app.pmdrs = pmdrs;
        //CONFIG
        this.config = this.defaultConfig();
        Object.assign(this.config, config);

        //ATTS
        this.wrapperClass = "pmdrs-admin-app";

        //init
        this.init();

        switch (this.config.type) {
            case "settings":
                this.widget = new Widget(app);
                this.widget.init();
                break;

            case "rates":
                this.widget = new WidgetRates(app);
                this.widget.init();
                break;
            default:
                console.error("Invalid config type for Admin App");
        }
    }

    defaultConfig() {
        return {
            elementId: "",
            isAdmin: false,
            type: "settings", //settings|rates
            vehicle: {
                vin: "all",
            },
        };
    }

    init() {
        this.addHtml();
    }

    addHtml() {
        document
            .querySelector("#" + this.config.elementId)
            .insertAdjacentHTML("beforeend", `<div class="pmdrs-admin-app">
				
</div>`);
    }

    getSelector(selector) {
        return "#" + this.config.elementId + " ." + this.wrapperClass + " " + selector;
    }
}
